import { render } from "./CoachProfile.vue?vue&type=template&id=59ef2610"
import script from "./CoachProfile.vue?vue&type=script&lang=js"
export * from "./CoachProfile.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__